import form from './index';
import { saveSettings } from './methods';
import { isEmpty } from 'lodash';
import { mapGetters, mapState } from 'vuex';

export default {
    data() {
        return {
            isFullPage: false,
            formData: {},
        };
    },
    created() {
        this.initComponentData();
    },
    computed:{
        ...form.computed,
        ...mapGetters('campaigns', [
            'currentCampaign'
        ]),
        ...mapGetters('authentication', [
            'company'
        ]),
        /*...mapState('settings', {
            company: (state) => state.company
        })*/
    },
    methods: {
        ...form.methods,
        saveSettings,
        initComponentData() { 
            const { data, fieldConfigurations } = this.initialSettingsData();
            this.formData = {
                ...this.formData,
                ...data
            };
            this.fieldConfigs = {
                ...this.fieldConfigs,
                ...fieldConfigurations
            };
            if (!isEmpty(this.currentCampaign)) {
                this.mergeSettingsData();
            }
        },
        validateAndSettingsForm($event) {
            $event.preventDefault(); 
            this.validateForm();
        },
        // called from validateForm in mixin form/methods.js
        areFieldsDirty() {
            return this.isComponentDirty();
        },
        mergeSettingsData() {
            if (isEmpty(this.currentCampaign)) {
                return;
            }
            const { settings } = this.currentCampaign;
            this.formData = {
                ...this.formData,
                ...settings
            }; 
            this.mergeFormData(settings); // in each of the settings component
        }
    },
    watch: {
        currentCampaign(to, from) {
            if (isEmpty(this.currentCampaign)) {
                return;
            }
            this.mergeSettingsData();
        }
    }
};
